import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagName, Flags, defaultFlags } from './flags';
import { useLocalFeatureFlag } from './useLocalFeatureFlag';

export function useFeatureFlag<T extends FlagName>(flagName: T): Flags[T] {
  const flags = useFlags();
  const [localFlag] = useLocalFeatureFlag(flagName);

  return localFlag ?? flags[flagName] ?? defaultFlags[flagName];
}
